import type { TagToAssetsMap } from './types';

function flatMapAndRemoveDuplicates(nestedArrayOfIds: string[][]) {
    return Array.from(new Set(nestedArrayOfIds.flat()));
}

export const getAssetsByTagIds = (tagToAssetMap: TagToAssetsMap, tagIds: string[]) => {
    if (tagIds.length === 0) {
        return;
    }

    const filteredAssetIds = Object.entries(tagToAssetMap)
        .filter(([tagId]) => tagIds.includes(tagId))
        .map(([, assetIds]) => assetIds);

    return flatMapAndRemoveDuplicates(filteredAssetIds);
};
